import * as React from 'react';
import PropTypes from 'prop-types';

function SizeChart({ product }) {
  let href;
  let usaSizing = false;

  switch (product.vendor) {
    case 'Annika':
      href = '/documents/cutter-buck-sizing-chart.jpg';
      usaSizing = true;
      break;
    case 'Bermuda Sands':
      href = '/documents/bermuda-sands-size-chart.jpeg';
      break;
    case 'Corsican Golf':
      break;
    case 'Corsican Sale':
      break;
    case 'Cutter & Buck':
      href = '/documents/cutter-buck-sizing-chart.jpg';
      usaSizing = true;
      break;
    case 'Daily Sports':
      break;
    case 'Greg Norman':
      if (product.tags.includes('Mens')) {
        break;
      }
      href = '/documents/greg-norman-sizing-chart-ladies.png';
      usaSizing = true;
      break;
    case 'IBKUL':
      if (product.tags.includes('Mens')) {
        href = '/documents/ibkul-mens-size-chart.pdf';
        break;
      }
      href = '/documents/ibkul-ladies-size-chart.pdf';
      break;
    case 'Jamie Sadock':
      href = '/documents/jamie-sadock-ladies-sizing-chart.pdf';
      break;
    case 'JoFit':
      href = '/documents/jofit-sizing-chart.pdf';
      break;
    case 'Nancy Lopez':
      href = '/documents/nancy-lopez-size-charts.pdf';
      break;
    case 'Nivo':
      href = '/documents/nivo-sizing-chart.jpg';
      break;
    case 'Nivo Sale':
      href = '/documents/nivo-sizing-chart.jpg';
      break;
    case 'Sporte Leisure':
      href = '/documents/sporte-leisure-sizing-chart.pdf';
      break;
    default:
      break;
  }

  if (
    product.productType === 'Gloves' ||
    product.productType === 'Headwear' ||
    product.productType === 'Accessories' ||
    product.productType === 'Shoes & Socks' ||
    product.productType === 'Gift Vouchers' ||
    product.productType === 'Cart Bags' ||
    product.productType === 'Wedges'
  )
    return null;

  return href ? (
    <span className="inline-flex w-full shadow-sm">
      <a
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        className="inline-flex items-center justify-center w-full px-4 py-2 text-base font-bold leading-6 tracking-wider text-center text-black uppercase transition duration-150 ease-in-out bg-white border border-gray-300 rounded-none hover:text-gray-400 focus:outline-none focus:shadow-outline-primary active:bg-gray-100 active:text-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        View {usaSizing && 'USA '}Sizing Chart
      </a>
    </span>
  ) : (
    ''
  );
}

SizeChart.propTypes = {
  product: PropTypes.shape({
    productType: PropTypes.string,
    vendor: PropTypes.string,
    tags: PropTypes.array,
  }),
};

export { SizeChart };
